import React, { useEffect, useRef, useState } from "react";
import styles from "./LeftRightTales.module.css";
import { FeatureItem } from "./FeatureItem";

interface LeftRightTalesProps {
  features: FeatureItem[];
}

const LeftRightTales: React.FC<LeftRightTalesProps> = ({ features }) => {
  const [visibleFeatures, setVisibleFeatures] = useState<number[]>([]);
  const featureRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const currentFeatureRefs = featureRefs.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = currentFeatureRefs.indexOf(
              entry.target as HTMLDivElement
            );
            if (index !== -1 && !visibleFeatures.includes(index)) {
              setVisibleFeatures((prev) => [...prev, index]);
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    currentFeatureRefs.forEach((ref) => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      currentFeatureRefs.forEach((ref) => {
        if (ref) {
          observer.unobserve(ref);
        }
      });
    };
  }, [visibleFeatures]);

  return (
    <section className={styles.features}>
      <div className={styles.container}>
        {features.map((feature, index) => (
          <div
            key={index}
            ref={(el) => {
              featureRefs.current[index] = el;
            }}
            className={`${styles.featureItem} ${
              feature.imagePosition === "right" ? styles.reverse : ""
            } ${visibleFeatures.includes(index) ? styles.visible : ""} ${
              feature.imagePosition === "right"
                ? styles["from-right"]
                : styles["from-left"]
            }`}
          >
            <div className={styles.imageWrapper}>
              <img
                src={feature.image}
                alt={feature.title}
                className={styles.image}
                loading="lazy"
              />
            </div>
            <div className={styles.content}>
              <h2 style={{ animationDelay: `${Math.random() * 4}s` }}>
                {feature.title}
              </h2>
              <p>{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LeftRightTales;
